<div *ngIf="successMessage" class="alert alert-success" role="alert">
	<mat-icon>thumb_up</mat-icon> &nbsp;
	<span style="vertical-align: text-bottom; margin-bottom: 0rem;">
		{{successMessage}}
	</span>
</div>

<div *ngIf="errorMessage" class="alert alert-danger" role="alert">

	<span style="vertical-align: text-bottom; margin-bottom: 0rem;">
		{{errorMessage}}
	</span>
</div>

<div class="row_1">
	<div class="top_grid_agg">
		<div class="content">
          <div style="width: 50%; justify-content: left; display: flex;">
            <button routerLink="/newtask" class="back_button col-sm-1">BACK</button>
          </div>
		  <div style="width: 50%; justify-content: right; display: flex;">
            <button class="add_button col-sm-1 float-right" (click)="addtask()">ADD TASK</button>
          </div>
        </div>
		<div class="period-form">
			<form class="form-horizontal hr">
				<div class="form-group row">
					<div class="col-sm-6">

						<div class="board-row">
							<label class="control-label col-sm-4">Board:
								<span style="color:#ff0000">*</span>
							</label>
							<div class="col-sm-8">
								<select [(ngModel)]="selected_board" [ngModelOptions]="{standalone: true}">
									<option *ngFor="let board of boardData" [value]="board.boardID">
										{{board.description}}
									</option>
								</select>
							</div>
						</div>

						<div class="task-row">
							<label class="control-label col-sm-4">Task:
								<span style="color:#ff0000">*</span>
							</label>
							<div class="col-sm-8">
								<!-- <select class="category" [(ngModel)]="selectedTask"
									[ngModelOptions]="{standalone: true}">
									<option *ngFor="let task of taskData" [value]="task.taskID">
										{{task.description}}
									</option>
								</select> -->
								<mat-form-field appearance="outline" class="fixed-select">
									<mat-select [(ngModel)]="selectedTask" placeholder="Select" name="taskSelect"
										panelClass="custom-task-panel">

										<!-- Search -->
										<mat-option disabled>
											<ngx-mat-select-search [formControl]="taskFilter" placeholderLabel="Search"
												noEntriesFoundLabel="No User found">
											</ngx-mat-select-search>
										</mat-option>

										<!-- Options -->
										<mat-option *ngFor="let user of filteredTasks | async" [value]="user">
											{{ user.label }}
										</mat-option>

									</mat-select>
								</mat-form-field>
								</div>
						</div>

						<div class="startweek-row">
							<label class="control-label col-sm-4">Start Month: <span
									style="color:#ff0000">*</span></label>
							<div class="col-sm-8">
								<input type="month" id="start" name="start" [(ngModel)]="selected_startmonth"
									[ngModelOptions]="{standalone: true}" [min]="minMonth" [max]="maxMonth"
									(change)="onStartMonthSet()">

							</div>
						</div>

						<div class="startweek-row">
							<label class="control-label col-sm-4">Month Type:</label>
							<div class="col-sm-8">
								<select id="startweek-drpdwn" [(ngModel)]="selected_monthtype"
									[ngModelOptions]="{standalone: true}">
									<option value="D">Day</option>
									<option value="W">Week Day</option>
								</select>
							</div>
						</div>



						<div class="startweek-row" *ngIf="selected_monthtype=='D'||selected_monthtype==undefined">
							<label class="control-label col-sm-4">Day of the Month: <span style="color:#ff0000">*</span>
							</label>
							<div class="col-sm-8">
								<input type="number" min="1" [max]="maxDateOfMonth" [(ngModel)]="dayofMonth"
									[ngModelOptions]="{standalone: true}">
							</div>
						</div>




						<div class="startweek-row" *ngIf="selected_monthtype=='W'">
							<label class="control-label col-sm-4">Pattern: </label>
							<div class="col-sm-8">



								<select id="startweek-drpdwn" [(ngModel)]="selected_pattern"
									[ngModelOptions]="{standalone: true}">
									<option value="1">First</option>
									<option value="2">Second</option>
									<option value="3">Third</option>
									<option value="4">Fourth</option>
									<option value="5">Last</option>
								</select>


							</div>
						</div>





						<div class="startweek-row" *ngIf="selected_monthtype=='W'">
							<label class="control-label col-sm-4">Day of the Week: </label>
							<div class="col-sm-8">


								<select id="startweek-drpdwn" [(ngModel)]="dayofWeek"
									[ngModelOptions]="{standalone: true}">
									<option value="1">Sun</option>
									<option value="2">Mon</option>
									<option value="3">Tue</option>
									<option value="4">Wed</option>
									<option value="5">Thu</option>
									<option value="6">Fri</option>
									<option value="7">Sat</option>
								</select>

							</div>
						</div>


						<div class="recur-row">
							<label class="control-label col-sm-4">Recur every X Month(s): </label>
							<div class="col-sm-8">
								<input type="number" min="1" max="12" [(ngModel)]="selected_recureveryweek"
									[ngModelOptions]="{standalone: true}">
							</div>
						</div>

						<div class="occurance-row">
							<label class="control-label col-sm-4">Occurences: </label>
							<div class="col-sm-8">
								<input type="number" min="1" max="50" [(ngModel)]="selected_occurance"
									[ngModelOptions]="{standalone: true}">
							</div>
						</div>

						<div class="due-row">
							<label class="control-label col-sm-4">Due Time:
								<p class="due-desc">(Leave blank for midnight) &nbsp;</p>

							</label>
							<div class="col-sm-8">
								<select id="category-drop-down" class="dueTime" [(ngModel)]="selected_duetime"
									[ngModelOptions]="{standalone: true}">
									<option [value]="option" *ngFor="let option of options">{{option}}</option>
								</select>
							</div>
						</div>

						<div class="primaryuser-row">
							<label class="control-label col-sm-4">Primary User:
								<span *ngIf="s_region_flag" style="color:#ff0000">*</span>
							</label>
							<div class="col-sm-8">
								
								<mat-form-field appearance="outline" class="fixed-select">
									<mat-select [(ngModel)]="selected_puser" name="puser"
												placeholder="Select" >
								
									<mat-option disabled>
										<div style="display: flex; align-items: center; position: sticky; top: 0; background: white; z-index: 2; width: 100%;">
								
										<ngx-mat-select-search
											[formControl]="puserFilter"
											placeholderLabel="Search"
											noEntriesFoundLabel="No User found"
											style="flex: 1;">
										</ngx-mat-select-search>
										</div>
									</mat-option>
									<div style="max-height: 200px; overflow-y: auto;">

									<mat-option *ngFor="let user of filteredPusers | async" [value]="user">
										{{ user.label }}
									</mat-option>
								</div>
									</mat-select>
								</mat-form-field>
	
							 
							</div>
						</div>

						<div class="secondaryuser-row">
							<label class="control-label col-sm-4" for="fname">Secondary User:</label>
							<div class="col-sm-8">
								<mat-form-field appearance="outline" class="fixed-select">
									<mat-select [(ngModel)]="selected_suser" name="suser"
												placeholder="Select" >
								
									<mat-option disabled>
										<div style="display: flex; align-items: center; position: sticky; top: 0; background: white; z-index: 2; width: 100%;">
								
										<ngx-mat-select-search
											[formControl]="suserFilter"
											placeholderLabel="Search"
											noEntriesFoundLabel="No User found"
											style="flex: 1;">
										</ngx-mat-select-search>
										</div>
									</mat-option>
									<div style="max-height: 200px; overflow-y: auto;">

									<mat-option *ngFor="let user of filteredSusers | async" [value]="user">
										{{ user.label }}
									</mat-option>
								</div>
									</mat-select>
								</mat-form-field>
							</div>
						</div>
					</div>

					<div class="col-sm-6">
						<div class="region-row">
							<label class="control-label col-sm-4" for="fname">Region:
								<span *ngIf="!selected_puser" style="color:#ff0000">*</span>
							</label>
							<div class="multiselect col-sm-8">
							
								<mat-form-field appearance="outline" class="fixed-select">
									<mat-select [(ngModel)]="selected_region" name="region"
												[multiple]="true"
												placeholder="Select Region(s)"
												>
								
									<!-- Sticky Select All with Search Row -->
									<mat-option disabled>
										<div style="display: flex; align-items: center; position: sticky; top: 0; background: white; z-index: 2; width: 100%;">
										<!-- Real checkbox -->
										<mat-checkbox
											[checked]="isAllSelected()"
											[indeterminate]="isIndeterminate()"
											(change)="toggleSelectAll($event)"
											style="margin-right: 8px;">
										</mat-checkbox>
								
										<!-- Search box -->
										<ngx-mat-select-search
											[formControl]="regionFilterCtrl"
											placeholderLabel="Search"
											noEntriesFoundLabel="No regions found"
											style="flex: 1;">
										</ngx-mat-select-search>
										</div>
									</mat-option>
									<div style="max-height: 200px; overflow-y: auto;">

									<!-- Options -->
									<mat-option *ngFor="let user of filteredRegions | async" [value]="user">
										{{ user.label }}
									</mat-option>
								</div>
									</mat-select>
								</mat-form-field>
							
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>